import { useUpdateDeviceSerialNoMutation } from "../../store/storageRoles/devicesSharedApi";

const useUpdateDeviceSerialNo = () => {
  const [
    updateDeviceSerialNo,
    {
      data: updateDeviceSerialNoData,
      isLoading: updateDeviceSerialNoIsLoading,
      isSuccess: updateDeviceSerialNoIsSuccess,
      isError: updateDeviceSerialNoIsError,
      error: updateDeviceSerialNoError,
    },
  ] = useUpdateDeviceSerialNoMutation();

  return {
    updateDeviceSerialNo,
    updateDeviceSerialNoIsLoading,
    updateDeviceSerialNoIsSuccess,
    updateDeviceSerialNoIsError,
    updateDeviceSerialNoError,
    updateDeviceSerialNoData,
  };
};

export default useUpdateDeviceSerialNo;
